import { motion } from "framer-motion";
import { maskLine, easeLux } from "@/lib/motion";

/**
 * Revelado tipo máscara línea por línea.
 * Pasa `lines` como array de strings (o nodos). Cada línea sube desde abajo
 * dentro de un contenedor con overflow oculto.
 */
export const MaskText = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  animate = "onLoad", // "onLoad" | "inView"
  testId,
}) => {
  const container = {
    hidden: {},
    show: { transition: { delayChildren: delay, staggerChildren: stagger } },
  };

  const motionProps =
    animate === "inView"
      ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.4 } }
      : { initial: "hidden", animate: "show" };

  return (
    <motion.span
      className={`block ${className}`}
      variants={container}
      data-testid={testId}
      {...motionProps}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            variants={maskLine}
            transition={{ duration: 1, ease: easeLux }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export default MaskText;
